import { ref as A, onMounted as H, openBlock as s, createElementBlock as l, getCurrentScope as gt, onScopeDispose as ft, unref as T, watch as V, createElementVNode as u, toDisplayString as m, withDirectives as mt, Fragment as w, renderList as k, normalizeClass as O, vShow as pt, createCommentVNode as S, createVNode as N, createBlock as E, mergeModels as K, useModel as W, normalizeStyle as Z, inject as R, computed as y, Transition as ht, withCtx as nt, withModifiers as yt, renderSlot as at, createTextVNode as bt, provide as X, resolveDynamicComponent as vt, isRef as _t } from "vue";
const Ct = ["innerHTML"], U = {
  __name: "icon",
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const o = A("");
    return H(async () => {
      const e = `https://digitallink-us-east-1-prod.s3.us-east-1.amazonaws.com/smartpage-content/icons/${t.name}.svg`;
      try {
        const n = await fetch(e);
        n.ok ? o.value = await n.text() : console.error("Error al cargar el SVG:", n.status);
      } catch (n) {
        console.error("Error al cargar el SVG:", n);
      }
    }), (e, n) => (s(), l("div", { innerHTML: o.value }, null, 8, Ct));
  }
};
function $t(t) {
  return gt() ? (ft(t), !0) : !1;
}
function B(t) {
  return typeof t == "function" ? t() : T(t);
}
const ot = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const wt = Object.prototype.toString, St = (t) => wt.call(t) === "[object Object]", F = () => {
}, Tt = /* @__PURE__ */ kt();
function kt() {
  var t, o;
  return ot && ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((o = window == null ? void 0 : window.navigator) == null ? void 0 : o.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
const it = ot ? window : void 0;
function P(t) {
  var o;
  const i = B(t);
  return (o = i == null ? void 0 : i.$el) != null ? o : i;
}
function z(...t) {
  let o, i, e, n;
  if (typeof t[0] == "string" || Array.isArray(t[0]) ? ([i, e, n] = t, o = it) : [o, i, e, n] = t, !o)
    return F;
  Array.isArray(i) || (i = [i]), Array.isArray(e) || (e = [e]);
  const a = [], r = () => {
    a.forEach((v) => v()), a.length = 0;
  }, d = (v, _, C, I) => (v.addEventListener(_, C, I), () => v.removeEventListener(_, C, I)), g = V(
    () => [P(o), B(n)],
    ([v, _]) => {
      if (r(), !v)
        return;
      const C = St(_) ? { ..._ } : _;
      a.push(
        ...i.flatMap((I) => e.map((D) => d(v, I, D, C)))
      );
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    g(), r();
  };
  return $t(f), f;
}
let Y = !1;
function Lt(t, o, i = {}) {
  const { window: e = it, ignore: n = [], capture: a = !0, detectIframe: r = !1 } = i;
  if (!e)
    return F;
  Tt && !Y && (Y = !0, Array.from(e.document.body.children).forEach((p) => p.addEventListener("click", F)), e.document.documentElement.addEventListener("click", F));
  let d = !0;
  const g = (p) => B(n).some((b) => {
    if (typeof b == "string")
      return Array.from(e.document.querySelectorAll(b)).some(($) => $ === p.target || p.composedPath().includes($));
    {
      const $ = P(b);
      return $ && (p.target === $ || p.composedPath().includes($));
    }
  });
  function f(p) {
    const b = B(p);
    return b && b.$.subTree.shapeFlag === 16;
  }
  function v(p, b) {
    const $ = B(p), M = $.$.subTree && $.$.subTree.children;
    return M == null || !Array.isArray(M) ? !1 : M.some((q) => q.el === b.target || b.composedPath().includes(q.el));
  }
  const _ = (p) => {
    const b = P(t);
    if (p.target != null && !(!(b instanceof Element) && f(t) && v(t, p)) && !(!b || b === p.target || p.composedPath().includes(b))) {
      if (p.detail === 0 && (d = !g(p)), !d) {
        d = !0;
        return;
      }
      o(p);
    }
  };
  let C = !1;
  const I = [
    z(e, "click", (p) => {
      C || (C = !0, setTimeout(() => {
        C = !1;
      }, 0), _(p));
    }, { passive: !0, capture: a }),
    z(e, "pointerdown", (p) => {
      const b = P(t);
      d = !g(p) && !!(b && !p.composedPath().includes(b));
    }, { passive: !0 }),
    r && z(e, "blur", (p) => {
      setTimeout(() => {
        var b;
        const $ = P(t);
        ((b = e.document.activeElement) == null ? void 0 : b.tagName) === "IFRAME" && !($ != null && $.contains(e.document.activeElement)) && o(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => I.forEach((p) => p());
}
const L = (t, o) => {
  const i = t.__vccOpts || t;
  for (const [e, n] of o)
    i[e] = n;
  return i;
}, It = { class: "text-primary font-semibold text-[12px] uppercase" }, xt = { class: "absolute right-0 w-[4.5rem] z-10 mt-1 bg-white border border-gray-200 rounded-md shadow-lg" }, At = { class: "py-1 px-1 max-h-40 overflow-y-auto scrollbar-hide" }, Et = ["onClick"], Ot = /* @__PURE__ */ Object.assign({
  name: "LanguageSelector"
}, {
  __name: "LanguageSelector",
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    initialLanguage: {
      type: String,
      default: "en"
    }
  },
  emits: ["changeLanguage"],
  setup(t, { emit: o }) {
    const i = o, e = A(null), n = A(t.initialLanguage), a = A(!1), r = () => {
      a.value = !a.value;
    }, d = () => {
      a.value = !1;
    }, g = (f) => {
      n.value = f, d(), i("changeLanguage", f);
    };
    return Lt(e, () => {
      d();
    }), H(() => {
      t.languages.length > 0 && g(t.languages.find(({ id: f }) => f === t.initialLanguage).id);
    }), (f, v) => t.languages.length > 0 ? (s(), l("div", {
      key: 0,
      ref_key: "target",
      ref: e,
      class: "relative inline-block text-left"
    }, [
      u("button", {
        onClick: r,
        class: "flex items-center gap-2 px-4 py-2 rounded-md bg-[#615DF414] focus:outline-none"
      }, [
        u("span", It, m(n.value), 1),
        v[0] || (v[0] = u("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "9",
          height: "14",
          viewBox: "0 0 9 14",
          fill: "none"
        }, [
          u("path", {
            d: "M4.6143 2C4.54149 2 4.47159 2.01602 4.4046 2.04806C4.34053 2.08009 4.27208 2.12524 4.19927 2.18349L1.41203 4.43775C1.29262 4.53386 1.23291 4.66201 1.23291 4.82219C1.23291 4.92122 1.25767 5.01005 1.30718 5.08869C1.35669 5.16732 1.42077 5.22994 1.4994 5.27654C1.57804 5.32314 1.66396 5.34644 1.75716 5.34644C1.82123 5.34644 1.88531 5.33333 1.94938 5.30712C2.01345 5.28091 2.07753 5.24305 2.1416 5.19353L4.61867 3.2014L7.09573 5.19353C7.15689 5.24305 7.21951 5.28091 7.28359 5.30712C7.34766 5.33333 7.41174 5.34644 7.47581 5.34644C7.56901 5.34644 7.65493 5.32314 7.73357 5.27654C7.8122 5.22994 7.87628 5.16732 7.92579 5.08869C7.9753 5.01005 8.00006 4.92122 8.00006 4.82219C8.00006 4.66201 7.94181 4.53386 7.82531 4.43775L5.0337 2.18349C4.96088 2.12524 4.89099 2.08009 4.824 2.04806C4.75992 2.01602 4.69002 2 4.6143 2ZM4.6143 12C4.69002 12 4.75992 11.984 4.824 11.9519C4.89099 11.9199 4.96088 11.8748 5.0337 11.8165L7.82531 9.55789C7.94181 9.46177 8.00006 9.33508 8.00006 9.17781C8.00006 9.07587 7.9753 8.98558 7.92579 8.90695C7.87628 8.8254 7.8122 8.76278 7.73357 8.71909C7.65493 8.6754 7.56901 8.65356 7.47581 8.65356C7.41174 8.65356 7.34766 8.66667 7.28359 8.69288C7.21951 8.71618 7.15689 8.75404 7.09573 8.80647L4.61867 10.7986L2.1416 8.80647C2.07753 8.75404 2.01345 8.71618 1.94938 8.69288C1.88531 8.66667 1.82123 8.65356 1.75716 8.65356C1.66396 8.65356 1.57804 8.6754 1.4994 8.71909C1.42077 8.76278 1.35669 8.8254 1.30718 8.90695C1.25767 8.98558 1.23291 9.07587 1.23291 9.17781C1.23291 9.33508 1.29262 9.46177 1.41203 9.55789L4.19927 11.8165C4.27208 11.8719 4.34053 11.9155 4.4046 11.9476C4.47159 11.9825 4.54149 12 4.6143 12Z",
            fill: "#121212",
            "fill-opacity": "0.6"
          })
        ], -1))
      ]),
      mt(u("div", xt, [
        u("ul", At, [
          (s(!0), l(w, null, k(t.languages, (_) => (s(), l("li", {
            key: _.id,
            class: O(["p-2 m-1 text-[#121212] text-[12px] rounded-md cursor-pointer hover:bg-[#615DF414] hover:text-primary uppercase", { "bg-primary !text-white hover:bg-primary": n.value === _.id }]),
            onClick: (C) => g(_.id)
          }, m(_.id), 11, Et))), 128))
        ])
      ], 512), [
        [pt, a.value]
      ])
    ], 512)) : S("", !0);
  }
}), Nt = /* @__PURE__ */ L(Ot, [["__scopeId", "data-v-ffc6cbd8"]]), Mt = {
  class: "flex items-center justify-between h-full",
  style: { gap: "10px" }
}, jt = { class: "flex gap-2" }, Pt = { class: "title" }, Bt = /* @__PURE__ */ Object.assign({
  name: "SmartPageHeader"
}, {
  __name: "SmartPageHeader",
  props: {
    title: {
      type: String,
      required: !0
    },
    languages: {
      type: Array,
      default: () => []
    },
    initialLanguage: {
      type: String,
      default: "en"
    },
    showLanguageSelector: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["changeLanguage"],
  setup(t) {
    return (o, i) => (s(), l("div", Mt, [
      u("div", jt, [
        N(U, {
          name: "dl-logo",
          alt: "logo",
          style: { height: "30px", "max-width": "20px" }
        }),
        u("div", Pt, m(t.title ?? ""), 1)
      ]),
      t.showLanguageSelector ? (s(), E(Nt, {
        key: 0,
        languages: t.languages,
        "initial-language": t.initialLanguage,
        onChangeLanguage: i[0] || (i[0] = (e) => o.$emit("changeLanguage", e))
      }, null, 8, ["languages", "initial-language"])) : S("", !0)
    ]));
  }
}), Rt = [
  {
    code: "kcal",
    childs: ["energy", "ener-"]
  },
  {
    code: "fat",
    childs: ["fat"]
  },
  {
    code: "hidr",
    // hidrato de carbono,
    childs: ["choavl", "carbohydrates"]
  },
  {
    code: "prot",
    childs: ["proteins", "pro-"]
  },
  {
    code: "fiber",
    childs: ["fiber", "fibtg"]
  }
], Dt = (t = []) => Rt.map((o) => t.find((i) => o.childs.includes(i.code))).slice(0, 5).filter((o) => o), qt = { class: "tabs-container overflow-x-auto max-h-16 w-full" }, Ft = ["onClick"], Gt = { class: "text-ellipsis whitespace-nowrap" }, zt = /* @__PURE__ */ Object.assign({
  name: "SmartPageFooter"
}, {
  __name: "SmartPageFooter",
  props: /* @__PURE__ */ K({
    tabs: {
      type: Array,
      required: !0
    }
  }, {
    activeTab: { type: Object, required: !0 },
    activeTabModifiers: {}
  }),
  emits: ["update:activeTab"],
  setup(t) {
    const o = W(t, "activeTab"), i = (e) => {
      o.value = e;
    };
    return (e, n) => (s(), l("div", qt, [
      (s(!0), l(w, null, k(t.tabs, (a) => (s(), l("div", {
        key: a.id,
        class: "content",
        style: Z(a.customStyle),
        onClick: (r) => i(a)
      }, [
        o.value.id === a.id ? (s(), E(U, {
          key: 0,
          name: `${a.icon}filled`
        }, null, 8, ["name"])) : (s(), E(U, {
          key: 1,
          name: a.icon
        }, null, 8, ["name"])),
        u("p", Gt, m(e.$t(a.label)), 1)
      ], 12, Ft))), 128))
    ]));
  }
}), Vt = /* @__PURE__ */ L(zt, [["__scopeId", "data-v-a2b3add8"]]), st = ({ content: t, data: o }) => t.reduce((i, e) => {
  if (typeof e == "object")
    Object.keys(e).forEach((n) => {
      const a = e[n].reduce((r, d) => {
        var f;
        const g = ((f = o[n]) == null ? void 0 : f[d]) ?? null;
        return g && g !== "" && (r[d] = g), r;
      }, {});
      Object.keys(a).length > 0 && (i[n] = a);
    });
  else {
    const n = o[e] ?? null;
    n && n !== "" && (i[e] = n);
  }
  return i;
}, {}), tt = {
  netContent: "component.label.net.weight",
  drainedWeight: "component.label.drained.weight",
  pathName: "component.label.gtin",
  gtin: "component.label.gtin",
  default: "",
  do: "designation.page.title",
  ingredients: "ingredients.page.title",
  storage: "ingredients.page.storage.title",
  useMode: "use.tab.label",
  inci: "ingredients.page.inci.title",
  allergens: "allergens.tab.label",
  instructions: "manual.tab.label",
  precautions: "manual.page.precautions.title",
  sustainabilityInfo: "sustainability.page.title",
  emptyHeadContent: "component.empty.body.headline",
  emptyBodyContent: "component.empty.body.body",
  emptyCtaContent: "component.empty.body.cta"
}, G = (t, o) => {
  if (!o)
    return console.warn("Error en getTranslationsFields: ", "i18n no está definido"), t;
  try {
    const i = o.global.t, e = tt[t];
    return e ? i(e) : (console.warn(`La clave de traducción para "${t}" no está definida.`), i(tt.default) || "");
  } catch (i) {
    return console.error("Error en getTranslationsFields: ", i), "";
  }
}, rt = (t) => `https://digitallink-us-east-1-prod.s3.us-east-1.amazonaws.com/smartpage-content/ilustrations/${t}.png`, Ut = (t) => `https://digitallink-us-east-1-prod.s3.us-east-1.amazonaws.com/smartpage-content/icons/${t}.svg`, Ht = { class: "empty-state-wrapper" }, Kt = { class: "empty-state-content" }, Wt = ["src"], Zt = { class: "title" }, Qt = { class: "body" }, Jt = ["href"], Xt = {
  __name: "EmptyBody",
  setup(t) {
    const o = R("gtin"), i = R("i18n"), e = (n) => G(n, i);
    return (n, a) => (s(), l("div", Ht, [
      u("div", Kt, [
        u("img", {
          alt: "Empty state icon",
          src: T(rt)("ilustration3"),
          class: "icon w-1/6 h-1/6"
        }, null, 8, Wt),
        u("p", Zt, m(e("emptyHeadContent")), 1),
        u("p", Qt, m(e("emptyBodyContent")), 1),
        u("a", {
          class: "mt-6 bg-primary text-[14px] font-semibold text-white text-capitalize my-2 px-4 py-2 rounded-lg transition ease-in-out duration-[0.2]",
          href: `mailto:info@digital-link.com?subject=Edit info GTIN ${T(o)}`
        }, m(e("emptyCtaContent")), 9, Jt)
      ])
    ]));
  }
}, lt = /* @__PURE__ */ L(Xt, [["__scopeId", "data-v-8439c718"]]), Yt = {
  key: 0,
  class: "container"
}, te = { class: "text-2xl title my-3" }, ee = { class: "body" }, ne = { key: 0 }, ae = { key: 1 }, oe = /* @__PURE__ */ Object.assign({
  name: "AllergensContent",
  inheritAttrs: !1
}, {
  __name: "AllergensContent",
  props: {
    mayContains: {
      type: Array,
      default: () => []
    },
    contains: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const o = y(() => t.mayContains.length > 0 || t.contains.length > 0), i = R("i18n"), e = (a) => G(a, i);
    function n(a) {
      return a.join(", ").replace(/, ([^,]*)$/, ` ${i.global.t("common.text.and")} $1.`);
    }
    return (a, r) => o.value ? (s(), l("section", Yt, [
      u("div", te, m(e("allergens")), 1),
      u("div", ee, [
        t.contains.length > 0 ? (s(), l("p", ne, m(n(t.contains)), 1)) : S("", !0),
        t.mayContains.length > 0 ? (s(), l("p", ae, m(n(t.mayContains)), 1)) : S("", !0)
      ])
    ])) : (s(), E(lt, {
      key: 1,
      gtin: "gtin"
    }));
  }
}), ie = /* @__PURE__ */ L(oe, [["__scopeId", "data-v-f6d69981"]]), se = { key: 0 }, re = { class: "text-2xl my-3" }, le = { key: 0 }, ce = { class: "flex flex-col gap-3.5 list-decimal p-5" }, ue = ["innerHTML"], de = {
  key: 1,
  class: "content"
}, ge = { class: "text-2xl my-3" }, fe = ["innerHTML"], me = /* @__PURE__ */ Object.assign({
  name: "ExtraContent",
  inheritAttrs: !1
}, {
  __name: "ExtraContent",
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    contentToShow: {
      type: Array,
      default: () => []
    }
  },
  setup(t) {
    const o = R("i18n"), i = (a) => G(a, o), e = y(() => st({ content: t.contentToShow, data: t.data })), n = y(() => !Object.keys(e.value).length);
    return (a, r) => (s(), l(w, null, [
      (s(!0), l(w, null, k(e.value, (d, g) => (s(), l("section", {
        key: g,
        class: "m-3 mt-5 text-pretty"
      }, [
        typeof d == "object" ? (s(), l("div", se, [
          (s(!0), l(w, null, k(d, (f, v) => (s(), l("div", {
            key: v,
            class: "content"
          }, [
            u("span", re, m(i(v)), 1),
            typeof f == "object" ? (s(), l("div", le, [
              u("ol", ce, [
                (s(!0), l(w, null, k(f, (_, C) => (s(), l("li", { key: C }, m(_), 1))), 128))
              ])
            ])) : (s(), l("p", {
              key: 1,
              innerHTML: f
            }, null, 8, ue))
          ]))), 128))
        ])) : S("", !0),
        typeof d != "object" && d ? (s(), l("div", de, [
          u("span", ge, m(i(g) || d), 1),
          i(g) ? (s(), l("p", {
            key: 0,
            innerHTML: d
          }, null, 8, fe)) : S("", !0)
        ])) : S("", !0)
      ]))), 128)),
      n.value ? (s(), E(lt, { key: 0 })) : S("", !0)
    ], 64));
  }
}), pe = /* @__PURE__ */ L(me, [["__scopeId", "data-v-d04a53d8"]]), he = { class: "quantity" }, ye = { class: "unit" }, be = { class: "name flex-grow" }, ve = /* @__PURE__ */ Object.assign({
  name: "FeaturedContent",
  inheritAttrs: !1
}, {
  __name: "FeaturedContent",
  props: {
    featuredNutrientsList: {
      type: Array,
      required: !0
    }
  },
  setup(t) {
    return (o, i) => t.featuredNutrientsList.length ? (s(), l("div", {
      key: 0,
      class: "container",
      style: Z({ "grid-template-columns": `repeat(${t.featuredNutrientsList.length}, 1fr)` })
    }, [
      (s(!0), l(w, null, k(t.featuredNutrientsList, ({ quantity: e, unit: n, name: a }, r) => (s(), l("div", {
        key: r,
        class: "content"
      }, [
        u("div", null, [
          u("span", he, m(e), 1),
          u("span", ye, m(n), 1)
        ]),
        u("span", be, m(a), 1)
      ]))), 128))
    ], 4)) : S("", !0);
  }
}), _e = /* @__PURE__ */ L(ve, [["__scopeId", "data-v-5b13fc43"]]), et = ["energy", "ener-", "fat", "choavl", "carbohydrates", "fiber", "fibtg", "proteins", "pro-"], Ce = {
  energy: 0,
  "ener-": 1,
  fat: 2,
  fasat: 3,
  "saturated-fat": 4,
  famscis: 5,
  "monounsaturated-fat": 6,
  fapucis: 7,
  "polyunsaturated-fat": 8,
  choavl: 9,
  carbohydrates: 10,
  sugar: 11,
  sugars: 12,
  "sugar-": 13,
  starch: 14,
  fiber: 15,
  fibtg: 16,
  proteins: 17,
  "pro-": 18,
  salteq: 19,
  salt: 20
}, $e = {
  fasat: "fat",
  "saturated-fat": "fat",
  famscis: "fat",
  "monounsaturated-fat": "fat",
  fapucis: "fat",
  "polyunsaturated-fat": "fat",
  sugar: "choavl",
  sugars: "choavl",
  "sugar-": "choavl",
  starch: "choavl"
}, we = {
  "ener-": "ener-",
  energy: "energy"
}, Se = { class: "text-2xl font-bold table-title" }, Te = { class: "flex gap-0.5 row font-bold" }, ke = { class: "bg-gray-100 rounded q-mx-2 w-7/12 left-content" }, Le = { class: "bg-gray-100 rounded q-mx-2 w-5/12 text-right right-content" }, Ie = { class: "w-7/12" }, xe = { class: "w-5/12" }, Ae = /* @__PURE__ */ Object.assign({
  name: "TableOfContent",
  inheritAttrs: !1
}, {
  __name: "TableOfContent",
  props: {
    nutrientsList: {
      type: Array,
      default: () => []
    },
    tableTitle: {
      type: String,
      default: ""
    },
    servingQuantity: {
      type: [Number, String],
      default: 0
    },
    servingUnit: {
      type: String,
      default: ""
    }
  },
  setup(t) {
    const o = y(
      () => t.nutrientsList.map((n) => ({
        name: n.name,
        quantity: n.quantity,
        unit: n.unit,
        code: n.code,
        class: et.includes(n.code),
        leftContentClass: i(n.code),
        order: Ce[n.code] ?? 99
      })).sort((n, a) => n.order - a.order)
    ), i = (n) => et.includes($e[n]), e = (n, a, r) => {
      const d = r.toLowerCase();
      if (we[n]) {
        if (d === "kcal")
          return a === 0 ? `${a}kj / ${a}kcal` : `${Math.round(a * 4.184)}kj / ${a}${r}`;
        if (d === "kj")
          return a === 0 ? `${a}kj / ${a}kcal` : `${a}${r} / ${Math.round(a / 4.184)}kcal`;
      }
      return `${a}${r}`;
    };
    return (n, a) => (s(), l(w, null, [
      u("div", Se, m(n.$t(t.tableTitle)), 1),
      u("div", Te, [
        u("div", ke, m(n.$t("nutrition.table.column.1.title")), 1),
        u("div", Le, m(n.$t("nutrition.table.column.2.title", {
          quantity: t.servingQuantity,
          unit: t.servingUnit
        })), 1)
      ]),
      (s(!0), l(w, null, k(o.value, (r, d) => (s(), l("div", {
        key: d,
        class: O([{ "font-bold": r.class }, "flex gap-0.5 row"])
      }, [
        u("div", Ie, [
          u("div", {
            class: O(["left-content rounded q-mx-2", { "bg-gray-100": d % 2 !== 0 }])
          }, [
            u("span", {
              class: O({ "ml-4": r.leftContentClass })
            }, m(r.name), 3)
          ], 2)
        ]),
        u("div", xe, [
          u("div", {
            class: O(["text-right right-content rounded", { "bg-gray-100": d % 2 !== 0 }])
          }, m(e(r.code, r.quantity, r.unit)), 3)
        ])
      ], 2))), 128))
    ], 64));
  }
}), Ee = /* @__PURE__ */ L(Ae, [["__scopeId", "data-v-3a223484"]]), Oe = ["src", "alt"], Ne = {
  __name: "ilustration",
  props: {
    name: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const o = t, i = y(() => rt(o.name));
    return (e, n) => (s(), l("img", {
      src: i.value,
      alt: t.name
    }, null, 8, Oe));
  }
}, Me = { class: "modal-content" }, je = { class: "modal-header" }, Pe = { class: "modal-body" }, Be = { class: "modal-footer" }, Re = {
  __name: "CommonModal",
  props: /* @__PURE__ */ K({
    title: {
      type: String,
      default: ""
    }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const o = W(t, "open");
    return (i, e) => (s(), E(ht, { name: "modal" }, {
      default: nt(() => [
        o.value ? (s(), l("div", {
          key: 0,
          class: "modal-overlay",
          onClick: e[1] || (e[1] = yt((n) => o.value = !1, ["self"]))
        }, [
          u("div", Me, [
            u("div", je, m(t.title), 1),
            u("div", Pe, [
              at(i.$slots, "default", {}, void 0, !0)
            ]),
            u("div", Be, [
              u("button", {
                onClick: e[0] || (e[0] = (n) => o.value = !1)
              }, m(i.$t("component.button.close.label")), 1)
            ])
          ])
        ])) : S("", !0)
      ]),
      _: 3
    }));
  }
}, De = /* @__PURE__ */ L(Re, [["__scopeId", "data-v-eb2282b0"]]), qe = {
  Afghanistan: "004",
  Albania: "008",
  Algeria: "012",
  "American Samoa": "016",
  Andorra: "020",
  Angola: "024",
  Anguilla: "660",
  Antarctica: "010",
  "Antigua and Barbuda": "028",
  Argentina: "032",
  Armenia: "051",
  Aruba: "533",
  Australia: "036",
  Austria: "040",
  Azerbaijan: "031",
  Bahamas: "044",
  Bahrain: "048",
  Bangladesh: "050",
  Barbados: "052",
  Belarus: "112",
  Belgium: "056",
  Belize: "084",
  Benin: "204",
  Bermuda: "060",
  Bhutan: "064",
  Bolivia: "068",
  "Bosnia and Herzegovina": "070",
  Botswana: "072",
  Brazil: "076",
  "British Virgin Islands": "092",
  "Brunei Darussalam": "096",
  Bulgaria: "100",
  "Burkina Faso": "854",
  Burundi: "108",
  "Cabo Verde": "132",
  Cambodia: "116",
  Cameroon: "120",
  Canada: "124",
  "Cayman Islands": "136",
  "Central African Republic": "140",
  Chad: "148",
  Chile: "152",
  China: "156",
  Colombia: "170",
  Comoros: "174",
  "Congo (Congo-Brazzaville)": "178",
  "Cook Islands": "184",
  "Costa Rica": "188",
  Croatia: "191",
  Cuba: "192",
  Cyprus: "196",
  "Czech Republic": "203",
  Denmark: "208",
  Djibouti: "262",
  Dominica: "212",
  "Dominican Republic": "214",
  Ecuador: "218",
  Egypt: "818",
  "El Salvador": "222",
  "Equatorial Guinea": "226",
  Eritrea: "232",
  Estonia: "233",
  Eswatini: "748",
  Ethiopia: "231",
  Fiji: "242",
  Finland: "246",
  France: "250",
  "French Guiana": "254",
  "French Polynesia": "258",
  Gabon: "266",
  Gambia: "270",
  Georgia: "268",
  Germany: "276",
  Ghana: "288",
  Gibraltar: "292",
  Greece: "300",
  Greenland: "304",
  Grenada: "308",
  Guadeloupe: "312",
  Guam: "316",
  Guatemala: "320",
  Guernsey: "831",
  Guinea: "324",
  "Guinea-Bissau": "624",
  Guyana: "328",
  Haiti: "332",
  Honduras: "340",
  "Hong Kong": "344",
  Hungary: "348",
  Iceland: "352",
  India: "356",
  Indonesia: "360",
  Iran: "364",
  Iraq: "368",
  Ireland: "372",
  "Isle of Man": "833",
  Israel: "376",
  Italy: "380",
  Jamaica: "388",
  Japan: "392",
  Jersey: "832",
  Jordan: "400",
  Kazakhstan: "398",
  Kenya: "404",
  Kiribati: "296",
  Kuwait: "414",
  Kyrgyzstan: "417",
  Laos: "418",
  Latvia: "428",
  Lebanon: "422",
  Lesotho: "426",
  Liberia: "430",
  Libya: "434",
  Liechtenstein: "438",
  Lithuania: "440",
  Luxembourg: "442",
  Madagascar: "450",
  Malawi: "454",
  Malaysia: "458",
  Maldives: "462",
  Mali: "466",
  Malta: "470",
  "Marshall Islands": "584",
  Martinique: "474",
  Mauritania: "478",
  Mauritius: "480",
  Mexico: "484",
  Moldova: "498",
  Monaco: "492",
  Mongolia: "496",
  Montenegro: "499",
  Montserrat: "500",
  Morocco: "504",
  Mozambique: "508",
  Myanmar: "104",
  Namibia: "516",
  Nauru: "520",
  Nepal: "524",
  Netherlands: "528",
  "New Caledonia": "540",
  "New Zealand": "554",
  Nicaragua: "558",
  Niger: "562",
  Nigeria: "566",
  Niue: "570",
  "Norfolk Island": "574",
  "North Korea": "408",
  "North Macedonia": "807",
  Norway: "578",
  Oman: "512",
  Pakistan: "586",
  Palau: "585",
  Panama: "591",
  "Papua New Guinea": "598",
  Paraguay: "600",
  Peru: "604",
  Philippines: "608",
  Poland: "616",
  Portugal: "620",
  "Puerto Rico": "630",
  Qatar: "634",
  Romania: "642",
  Russia: "643",
  Rwanda: "646",
  "Saint Kitts and Nevis": "659",
  "Saint Lucia": "662",
  "Saint Vincent and the Grenadines": "670",
  Samoa: "882",
  "San Marino": "674",
  "Sao Tome and Principe": "678",
  "Saudi Arabia": "682",
  Senegal: "686",
  Serbia: "688",
  Seychelles: "690",
  "Sierra Leone": "694",
  Singapore: "702",
  Slovakia: "703",
  Slovenia: "705",
  "Solomon Islands": "090",
  Somalia: "706",
  "South Africa": "710",
  "South Korea": "410",
  "South Sudan": "728",
  Spain: "724",
  "Sri Lanka": "144",
  Sudan: "729",
  Suriname: "740",
  Sweden: "752",
  Switzerland: "756",
  Syria: "760",
  Taiwan: "158",
  Tajikistan: "762",
  Tanzania: "834",
  Thailand: "764",
  "Timor-Leste": "626",
  Togo: "768",
  Tonga: "776",
  "Trinidad and Tobago": "780",
  Tunisia: "788",
  Turkey: "792",
  Turkmenistan: "795",
  Tuvalu: "798",
  Uganda: "800",
  Ukraine: "804",
  "United Arab Emirates": "784",
  "United Kingdom": "826",
  "United States": "840",
  Uruguay: "858",
  Uzbekistan: "860",
  Vanuatu: "548",
  "Vatican City": "336",
  Venezuela: "862",
  Vietnam: "704",
  Yemen: "887",
  Zambia: "894",
  Zimbabwe: "716"
}, Fe = { class: "qualifiers_content__label" }, Ge = { class: "qualifiers_content__value" }, ze = { class: "qualifiers_content__label" }, Ve = { class: "qualifiers_content__value" }, Ue = {
  __name: "DynamicDataModal",
  props: /* @__PURE__ */ K({
    qualifiers: {
      type: Object,
      required: !0
    },
    attributes: {
      type: Object,
      required: !0
    }
  }, {
    open: { type: Boolean, required: !0 },
    openModifiers: {}
  }),
  emits: ["update:open"],
  setup(t) {
    const o = W(t, "open"), i = {
      10: "component.modal.add.data.batch.label",
      // batch
      17: "component.modal.add.data.exp.date.label",
      // expiration date
      // 22: 'component.modal.add.data.exp.date.label', // expiration date
      21: "component.modal.add.data.serial.number.label",
      // serial number,
      22: "component.modal.add.data.cpv.label",
      13: "component.modal.add.data.packaging.date.label",
      3100: "component.modal.add.data.net.weight.label",
      422: "component.modal.add.data.country.origin.label",
      15: "dashboard.link.configuration.best.before.label",
      11: "dashboard.link.configuration.production.date.label"
    }, e = {
      BATCH: 10,
      SERIAL_NUMBER: 21,
      EXPIRATION_DATE: 17,
      BEST_BEFORE_DATE: 15,
      PRODUCTION_DATE: 11,
      EXPIRATION_DATE_OLD: 22,
      CPV: 22,
      PACKAGING_DATE: 13,
      NET_WEIGHT: 3100,
      COUNTRY_OF_ORIGIN: 422,
      VARIANT: "qrVariant"
    }, n = (r) => i[r], a = (r, d) => {
      var g;
      return +d !== e.COUNTRY_OF_ORIGIN ? r : ((g = Object.entries(qe).find(([, f]) => f === r)) == null ? void 0 : g[0]) + ` (${r})`;
    };
    return (r, d) => (s(), E(De, {
      open: o.value,
      "onUpdate:open": d[0] || (d[0] = (g) => o.value = g),
      title: r.$t("dashboard.key.qualifiers.label")
    }, {
      default: nt(() => [
        (s(!0), l(w, null, k(t.qualifiers, (g, f) => (s(), l("div", {
          key: f,
          class: "qualifiers_content"
        }, [
          u("span", Fe, m(r.$t(n(f))), 1),
          u("span", Ge, m(g), 1)
        ]))), 128)),
        (s(!0), l(w, null, k(t.attributes, (g, f) => (s(), l("div", {
          key: f,
          class: "qualifiers_content"
        }, [
          u("span", ze, m(r.$t(n(f))), 1),
          u("span", Ve, m(a(g, f)), 1)
        ]))), 128))
      ]),
      _: 1
    }, 8, ["open", "title"]));
  }
}, He = /* @__PURE__ */ L(Ue, [["__scopeId", "data-v-c2929dc7"]]), Ke = {
  id: "product-info",
  class: "flex flex-nowrap"
}, We = { class: "w-1/2" }, Ze = ["innerHTML"], Qe = { key: 0 }, Je = {
  key: 0,
  id: "extra-logo"
}, Xe = {
  key: 1,
  class: "my-1"
}, Ye = { class: "w-1/2 flex justify-center items-center p-2" }, tn = ["src"], en = ["src"], nn = /* @__PURE__ */ Object.assign({
  name: "ProductInfo",
  inheritAttrs: !1
}, {
  __name: "ProductInfo",
  props: {
    description: { type: String, required: !0 },
    extraLogo: { type: String, default: void 0 },
    thumbnail: { type: String, default: void 0 },
    data: {
      type: Object,
      default: () => ({})
    },
    topContentToShow: {
      type: Array,
      default: () => []
    },
    qualifiers: {
      type: Object,
      default: () => ({})
    },
    attributes: {
      type: Object,
      default: () => ({})
    },
    isVariant: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const o = R("i18n"), i = (a) => G(a, o), e = A(!1), n = y(() => st({ content: t.topContentToShow, data: t.data }));
    return (a, r) => (s(), l("div", Ke, [
      u("div", We, [
        u("p", {
          class: "description mb-4",
          innerHTML: t.description
        }, null, 8, Ze),
        (s(!0), l(w, null, k(n.value, (d, g) => (s(), l("section", { key: g }, [
          typeof d == "object" ? (s(), l("span", Qe, [
            bt(m(i(g)) + " ", 1),
            (s(!0), l(w, null, k(d, (f, v) => (s(), l("span", { key: v }, m(f), 1))), 128))
          ])) : (s(), l("span", {
            key: 1,
            class: O({ "font-semibold": g === "gtin" })
          }, m(i(g)) + " " + m(d), 3))
        ]))), 128)),
        t.extraLogo ? (s(), l("section", Je, [
          N(Ne, { name: t.extraLogo }, null, 8, ["name"])
        ])) : S("", !0),
        t.isVariant ? (s(), l("div", Xe, [
          u("button", {
            onClick: r[0] || (r[0] = (d) => e.value = !0),
            class: "hover:bg-primary-hover text-capitalize my-2 text-primary p-2 rounded-lg transition ease-in-out duration-[0.2]"
          }, m(a.$t("dashboard.key.qualifiers.label")), 1),
          N(He, {
            attributes: t.attributes,
            qualifiers: t.qualifiers,
            open: e.value,
            "onUpdate:open": r[1] || (r[1] = (d) => e.value = d)
          }, null, 8, ["attributes", "qualifiers", "open"])
        ])) : S("", !0)
      ]),
      u("div", Ye, [
        t.thumbnail ? (s(), l("img", {
          key: 0,
          alt: "product-logo",
          src: t.thumbnail,
          class: "max-h-[100px] object-scale-down",
          loading: "lazy"
        }, null, 8, tn)) : (s(), l("img", {
          key: 1,
          alt: "empty-logo",
          src: T(Ut)("empty-img"),
          class: "max-h-[100px] object-scale-down",
          loading: "lazy"
        }, null, 8, en))
      ])
    ]));
  }
}), an = /* @__PURE__ */ L(nn, [["__scopeId", "data-v-e0a236cb"]]), on = {
  PRODUCT_INFO: an,
  ALLERGENS: ie,
  EXTRA_CONTENT: pe,
  FEATURED_CONTENT: _e,
  TABLE_OF_CONTENT: Ee
}, sn = {
  key: 0,
  class: "m-0 text-black"
}, rn = {
  __name: "TabTitle",
  props: {
    tabTitle: {
      type: String,
      default: void 0
    }
  },
  setup(t) {
    return (o, i) => t.tabTitle ? (s(), l("h2", sn, m(o.$t(t.tabTitle)), 1)) : S("", !0);
  }
}, ln = "https://api.digital-link.com", cn = "/api/landing-template-configs/7ca55d7e-d8fb-11ef-b10f-76f0d7b87707", un = (t) => {
  const o = A({}), i = A(!1), e = y(() => {
    var r;
    return ((r = o.value[t]) == null ? void 0 : r.tabs) || [];
  }), n = A({});
  async function a() {
    try {
      i.value = !0;
      const d = await (await fetch(`${ln}${cn}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })).json();
      o.value = d.config, n.value = e.value.find((g) => {
        var f;
        return g.id === ((f = o.value[t]) == null ? void 0 : f.activeTab);
      });
    } catch (r) {
      console.log(r);
    } finally {
      i.value = !1;
    }
  }
  return H(a), {
    smartPagesTypes: y(() => o.value),
    isLoading: i,
    activeTab: n,
    tabs: e
  };
}, dn = {
  key: 0,
  class: "flex justify-center items-center rounded-lg"
}, gn = { class: "w-full smartpage-header" }, fn = {
  key: 0,
  class: "flex-grow smartpage-body text-pretty"
}, mn = {
  key: 1,
  class: "flex-grow overflow-y-auto"
}, pn = { class: "w-full smartpage-footer" }, hn = /* @__PURE__ */ Object.assign({
  name: "SmartPage"
}, {
  __name: "SmartPage",
  props: {
    productInfo: {
      type: Object,
      required: !0
    },
    tabSelected: {
      type: Number,
      default: 0
      // 0 = first tab / 1 = last tab
    },
    i18n: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: String,
      default: "100dvh"
    },
    showLanguageSelector: {
      type: Boolean,
      default: !0
    },
    languages: {
      type: Array,
      default: () => []
    },
    initialLanguage: {
      type: String,
      default: "en"
    }
  },
  emits: ["tabSwitch", "changeLanguage"],
  setup(t, { emit: o }) {
    var Q;
    const i = o, { smartPagesTypes: e, isLoading: n, activeTab: a, tabs: r } = un(t.productInfo.industry);
    X("gtin", (Q = t.productInfo) == null ? void 0 : Q.gtin), X("i18n", t.i18n);
    const d = y(() => {
      var c, h;
      return (h = e.value[(c = t.productInfo) == null ? void 0 : c.industry]) == null ? void 0 : h.logo;
    }), g = y(() => {
      var c;
      return ((c = a.value) == null ? void 0 : c.components) ?? [];
    }), f = y(() => {
      var c;
      return ((c = t.productInfo) == null ? void 0 : c.industry) ?? "food";
    }), v = y(() => {
      var c, h;
      return ((h = (c = t.productInfo) == null ? void 0 : c.allergens) == null ? void 0 : h.mayContain) ?? [];
    }), _ = y(() => {
      var c, h;
      return ((h = (c = t.productInfo) == null ? void 0 : c.allergens) == null ? void 0 : h.contains) ?? [];
    }), C = y(() => {
      var c, h;
      return (h = (c = t.productInfo) == null ? void 0 : c.basicInfo) == null ? void 0 : h.name;
    }), I = y(() => {
      var c;
      return (c = t.productInfo) == null ? void 0 : c.thumbnail;
    }), D = y(() => {
      var c, h;
      return ((h = (c = t.productInfo) == null ? void 0 : c.basicInfo) == null ? void 0 : h.description) ?? C.value;
    }), p = y(() => {
      var c, h;
      return ((h = (c = t.productInfo) == null ? void 0 : c.nutrientInfo) == null ? void 0 : h.nutrients) || [];
    }), b = y(() => {
      var c, h, x;
      return ((x = (h = (c = t.productInfo) == null ? void 0 : c.nutrientInfo) == null ? void 0 : h.serving) == null ? void 0 : x.quantity) || 0;
    }), $ = y(() => {
      var c, h, x;
      return ((x = (h = (c = t.productInfo) == null ? void 0 : c.nutrientInfo) == null ? void 0 : h.serving) == null ? void 0 : x.unit) || "";
    }), M = y(() => Dt(p.value)), q = y(() => {
      var c;
      return (c = t.productInfo) == null ? void 0 : c.isVariant;
    }), ct = y(() => {
      var c;
      return ((c = t.productInfo) == null ? void 0 : c.qualifiers) || [];
    }), ut = y(() => {
      var c;
      return ((c = t.productInfo) == null ? void 0 : c.attributes) || [];
    });
    return V(a, (c) => {
      c.isCompanyTab && i("tabSwitch", 1), c.id === 0 && i("tabSwitch", 0);
    }), V(
      () => t.tabSelected,
      (c) => {
        c === 0 && (a.value = r.value[0]), c === 1 && (a.value = r.value[r.value.length - 1]);
      }
    ), (c, h) => {
      var x, J;
      return T(n) ? S("", !0) : (s(), l("main", dn, [
        u("div", {
          style: Z({ height: t.height }),
          class: "flex flex-col root landing-borders shadow-lg"
        }, [
          u("div", gn, [
            N(Bt, {
              title: C.value,
              languages: t.languages,
              "initial-language": t.initialLanguage,
              "show-language-selector": t.showLanguageSelector,
              onChangeLanguage: h[0] || (h[0] = (j) => c.$emit("changeLanguage", j))
            }, null, 8, ["title", "languages", "initial-language", "show-language-selector"])
          ]),
          (x = T(a)) != null && x.isCompanyTab ? (s(), l("div", mn, [
            at(c.$slots, "company")
          ])) : (s(), l("div", fn, [
            N(rn, {
              "tab-title": (J = T(a)) == null ? void 0 : J.tabTitle
            }, null, 8, ["tab-title"]),
            (s(!0), l(w, null, k(g.value, (j, dt) => (s(), E(vt(T(on)[j]), {
              key: dt,
              "nutrients-list": p.value,
              "featured-nutrients-list": M.value,
              data: t.productInfo,
              description: D.value,
              industry: f.value,
              thumbnail: I.value,
              "extra-logo": d.value,
              nutrients: p.value,
              contains: _.value,
              "may-contains": v.value,
              "serving-quantity": b.value,
              "serving-unit": $.value,
              "content-to-show": T(a).contentToShow,
              "top-content-to-show": T(a).topContentToShow,
              "table-title": T(a).tableTitle,
              "is-variant": q.value,
              qualifiers: ct.value,
              attributes: ut.value
            }, null, 8, ["nutrients-list", "featured-nutrients-list", "data", "description", "industry", "thumbnail", "extra-logo", "nutrients", "contains", "may-contains", "serving-quantity", "serving-unit", "content-to-show", "top-content-to-show", "table-title", "is-variant", "qualifiers", "attributes"]))), 128))
          ])),
          u("div", pn, [
            N(Vt, {
              "active-tab": T(a),
              "onUpdate:activeTab": h[1] || (h[1] = (j) => _t(a) ? a.value = j : null),
              tabs: T(r)
            }, null, 8, ["active-tab", "tabs"])
          ])
        ], 4)
      ]));
    };
  }
}), bn = {
  install(t) {
    t.component("SmartPageLib", hn);
  }
};
export {
  bn as default
};
